import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type AppMode = 'guia' | 'obra'

interface ModeState {
  mode: AppMode
  setMode: (mode: AppMode) => void
  toggleMode: () => void
}

export const useModeStore = create<ModeState>()(
  persist(
    (set, get) => ({
      mode: 'guia',
      setMode: (mode) => set({ mode }),
      toggleMode: () => set({ mode: get().mode === 'guia' ? 'obra' : 'guia' }),
    }),
    { name: 'minha-obra-mode' },
  ),
)
